import { Component, OnInit, ViewEncapsulation,ViewChild } from '@angular/core';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import {ClaimsMasterService} from '../../../services';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../../shared/models/Global-Search.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../../shared/services/shared.service';


import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { ClaimsMaster } from '../../../models';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as fs from 'file-saver';

@Component({
  selector: 'app-claims-master-search',
  templateUrl: './claims-master-search.component.html',
  styleUrls: ['./claims-master-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class ClaimsMasterSearchComponent implements OnInit {


  
   //currentUser;
   showTopFilters: boolean;
   showFilters:boolean;
   showSorting:boolean;
   matchModeOptions: SelectItem[];
   matchModeOptionsForDate: SelectItem[];
   matchModeOptionsForNumeric: SelectItem[];
   showAddRuleButton:boolean = false;
   oldSortField:string = 'createdOn';
   oldSortOrder:string = 'desc';
   sortField:string = 'createdOn';
   sortOrder:string = 'desc';
   appliedFilters:{field:string,matchMode:string,value:string}[]=[];
   pageNo: number =1;
   pageSize: number =10;
   oldPageNo: number =1;
   oldPageSize: number =10;
   totalRecords: number;
   loadEvent: LazyLoadEvent;
   filters;
   filterCondition: { fieldName: string; type: string; }[] =[];
   startSearch: boolean = false;
   claimsMasterList;
   gridSpinner = 'gridSpinner1';
   isSearchLoading: boolean = false;
   loading: boolean = false;
   claimsMasterSearchParam:IGlobalSearchParam;
   items: MenuItem[];
   claimsMasterSearchSpinner = 'claimsMasterSearchSpinner';
   ref: DynamicDialogRef;
   msgs: Message[] = [];
   dialogPosition = 'topright';
   isClaimsMasterAdd : boolean = false;
   isClaimsMasterEdit : boolean = false;
   buttonLabel: string = "";
   title: string = "";
   claimsMasterForm:FormGroup;
   userFeatures = [];
   userClaims = [];
   selectedGridMenuItem:any = null;
   showToggle:boolean;
   isshowpaginator:boolean=true;
   statusValues:any;
selectedStatusId:any="All";
selectedStatus:any;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'featureName', header: 'Feature Name' },
    { value: 'claimType', header: 'Claims Type' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'featureName', header: 'Feature Name' },
    { value: 'claimType', header: 'Claims Type' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;

   constructor(
     public datepipe: DatePipe,
    // private storage: LocalStorageService,
     private spinner: NgxSpinnerService,
     private claimsMasterService:ClaimsMasterService,
     private dialogService: DialogService,
     private confirmationService: ConfirmationService,
     private messageService: MessageService,
     private primengConfig: PrimeNGConfig,
     private _fb: FormBuilder,
     private excelService:ExcelService,
     private _router: Router,
     public sharedService: SharedService
   ) 
   {
     this.showFilters = false;
     this.showSorting = false;
     this.spinner.show();
     setTimeout(() => {
         this.spinner.hide();
     }, 1000);
     /*this.items = [
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.claimMasterId)
      }
   ];*/
     //this.currentUser = this.storage.retrieve('currentuser');
     
    
   }
 
   ngOnInit(): void {

    this.checkViewPermission();
    this.items = [];
    this.checkDeletePermission();
     const customFilterName = "custom-equals";
     const notEquals = "not-equals";
     const dateAfter = "date-after";
     const dateBefore = "date-before";
     
     this.matchModeOptions = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
       { label: "Contains", value: FilterMatchMode.CONTAINS }
     ];
 
     this.matchModeOptionsForDate = [
       { label: "Equals", value: customFilterName },
       { label: "Not Equals", value: notEquals },
       { label: "Greater Than", value: dateAfter },
       { label: "Less Than", value: dateBefore },
     ];
 
     this.matchModeOptionsForNumeric = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
       { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
     ];
 
     this.filterCondition=[
       {fieldName:"featureName",type:"basic"},
       {fieldName:"claimType",type:"basic"},
       {fieldName:"isActive",type:"basic"},
       {fieldName:"createdBy",type:"basic"},
       {fieldName:"createdOn",type:"date"},
     ];
     this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
     this.getAllClaimsMasterList();
     this.statusValues=['All','Active',"Inactive"];
     this.InitialSetup();
     this.getFeatures();
   }
   checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }
   InitialSetup(){
     this.claimsMasterForm = this._fb.group({
       claimMasterId: new FormControl(0,[Validators.required]),
       featureId: new FormControl(0,[Validators.required]),
       claimTypeId: new FormControl(0,[Validators.required]),
       isActive: new FormControl(true,[Validators.required]),
       createdBy: new FormControl(1),
       createdOn: new FormControl(new Date()),
       modifiedBy: new FormControl(""),
       modifiedOn: new FormControl("")
     })
   }
   
   getAllClaimsMasterList()
   {
     this.claimsMasterSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.claimsMasterSearchSpinner);
     this.claimsMasterService.getAllClaimsMasters(this.claimsMasterSearchParam).subscribe((data: any) => {
       this.appliedFilters = [];
       this.claimsMasterList =data;
       this.isshowpaginator=this.claimsMasterList.length>0?true:false;
       console.log(this.claimsMasterList);
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.claimsMasterSearchSpinner);
      });
   }
 
 
   loadClaimsMasterList(event:LazyLoadEvent)
   { 
     this.loadEvent=event;
     if(event.first==0)
     {
       this.pageNo = 1;
     }
     else {
       this.pageNo=(event.first/event.rows)+1;
     }
     this.pageSize=event.rows;
     
     this.pageSize=event.rows;
     
     if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
     {
      this.applyFilter();
      this.getAllClaimsMasterList();
     }
     this.oldPageNo = this.pageNo;
     this.oldPageSize = this.pageSize;
     this.filters=event.filters;
     if(this.filters["createdOn"]!= undefined)
     {
     if(this.filters["createdOn"][0].matchMode == "date-after")
     {
        this.showAddRuleButton = true;
     }
     else{
       this.showAddRuleButton = false;
     }
    }
     this.sortField=event.sortField;
     if(event.sortField === undefined || event.sortField === null)
     {
       this.sortField='createdOn';
     }
     if(event.sortOrder === 1)
     {
     this.sortOrder='desc';
     }
     if(event.sortOrder === -1)
     {
     this.sortOrder='asc';
     }
     /*if(this.sortField !== 'createdOn')
     {
       this.getAllClaimsMasterList()
     }*/
 
     if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
     {
       this.applyFilter();
       this.getAllClaimsMasterList()
     }
     this.oldSortField = this.sortField;
     this.oldSortOrder = this.sortOrder;
   }
 
 
   search()
   {
     console.log(this.filterCondition.length);
     for(let i=0;i<this.filterCondition.length;i++)
     {
       if(this.filterCondition[i].type == "checkbox")
       {
         if(this.filters[this.filterCondition[i].fieldName].value == true)
         {
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"true"}) 
         }
         else if (this.filters[this.filterCondition[i].fieldName].value == false){
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"false"}) 
         }
       }
       else {
         this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:this.filters[this.filterCondition[i].fieldName].value}) 
       }
       if(i==this.filterCondition.length-1 )
       {
         this.startSearch = true; 
       } 
     }
     if(this.startSearch == true)
     {
       this.claimsMasterSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.claimsMasterSearchSpinner);
       this.claimsMasterService.getAllClaimsMasters(this.claimsMasterSearchParam).subscribe((data: any) => {
         this.appliedFilters = [];
         this.claimsMasterList =data;
         console.log(this.claimsMasterList);
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.claimsMasterSearchSpinner);
        });
     }
   }
 
 
 
 
   showClaimsMasterDetails(paramId: number)
   {
  //    this.ref = this.dialogService.open(ClaimsMasterViewModalComponent, {
  //      header: 'ClaimsMaster Details',
  //      width: '50%',
  //      contentStyle: {"max-height": "500px", "overflow": "auto"},
  //      baseZIndex: 10000,
  //      data: {id: paramId}
  //  });
   }
 
 
 
 
   deleteConfirm(paramId:number) {
     this.dialogPosition = 'topright';
     console.log('deleteConfirm deleteConfirm ');
     this.confirmationService.confirm({
       message: 'Do you want to delete this claimsMaster?',
       header: 'Delete Confirmation',
       icon: 'pi pi-info-circle',
       accept: () => {
         console.log("hi");
         this.userClaims = [];
         this.loading = true;
         this.claimsMasterService.deleteClaimsMaster(paramId).subscribe((data: any) => {
          this.getClaimTypeNotAdded();
           this.getAllClaimsMasterList();
           this.loading = false;
           this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
          });
       },
       reject: (type) => {
         switch(type) {
             case ConfirmEventType.REJECT:
                 this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
             break;
             case ConfirmEventType.CANCEL:
                 this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
             break;
         }
       },
       key: "positionDialog"
     });
   }
 
   addClaimsMasterDetails(){
     //this.InitialSetup();
     this.isClaimsMasterAdd = true;
     this.isClaimsMasterEdit = false;
     this.title = "ClaimsMaster Add";
     this.buttonLabel = "Save";
     this.userClaims = [];
    this.getClaimTypeNotAdded();
   }
 
  //  editClaimsMasterDetails(paramId: number)
  //  { 
  //    //this.InitialSetup();
  //    this.isClaimsMasterEdit = true;
  //    this.isClaimsMasterAdd = false;
  //    this.title = "ClaimsMaster Edit";
  //    this.buttonLabel = "Update";
  //    this.claimsMasterService.getClaimsMasterById(paramId).subscribe((data:ClaimsMaster) =>{
  //      this.claimsMasterForm.patchValue(data);
  //    },error => {
  //      console.log(error)
  //    })
  //  }
 
   cancel(){
     this.isClaimsMasterAdd = false;
     this.isClaimsMasterEdit = false;
   }
 
   save({value}: {value: ClaimsMaster}){
     console.log(value);
     this.loading = true;
     if(value.claimMasterId == 0){
       value.createdBy = 1;
       value.createdOn = new Date();
       this.claimsMasterService.postClaimsMaster(value).subscribe(data => {
         this.getAllClaimsMasterList();
         this.isClaimsMasterAdd = false;
         this.loading = false;
       }, error => {
         console.log(error)
       })
     }else{
       this.claimsMasterService.updateClaimsMaster(value.claimMasterId, value).subscribe(data => {
         this.getAllClaimsMasterList();
         this.isClaimsMasterEdit = false;
         this.loading = false;
       }, error => {
         console.log(error);
       })
     }
   }
 
   clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
     table.clear();
     this.selectedStatus="";
     this.selectedStatusId=undefined;
     this.appliedFilters = [];
    //  this.applyFilter();
    this.getAllClaimsMasterList();
   }
   
   bindShowFilter() {
     this.showFilters = (this.showFilters ? false : true)
   }
 
   bindShowSorting() {
     this.showSorting = (this.showSorting ? false : true)
   }
 
   bindShowTopFilter() {
     this.showTopFilters = (this.showTopFilters ? false : true)
   }
 
   applyFilterNew(table: Table){
     this.filters=table.filters;
     this.applyFilter();
   }
 
   applyFilter()
   {
     console.log(this.filterCondition.length);
     console.log(this.filterCondition);
     console.log(this.filters);
     if (Object.keys(this.filters).length > 1) {
       this.appliedFilters = [];
       for (let i = 0; i < this.filterCondition.length; i++) {
         if (this.filterCondition[i].type == "checkbox") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "true"
               })
             }
             else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "false"
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "basic") {
           console.log("filter type is basic");
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
               console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "date") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
               if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                 this.appliedFilters.push({
                   field: this.filterCondition[i].fieldName,
                   matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                   value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                 })
             }
           }
         }
         else if (this.filterCondition[i].type == "numeric") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
           }
         }
     }
     }
 
     if(this.startSearch == true || this.startSearch == false)
     {
       this.claimsMasterSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          //searchGlobalFilter: this.searchGlobalFilter,
          sortOrder:this.sortOrder
        };
       this.spinner.show(this.claimsMasterSearchSpinner);
       this.claimsMasterService.getAllClaimsMasters(this.claimsMasterSearchParam).subscribe((data: any) => {
       this.claimsMasterList =data;
       this.isshowpaginator=this.claimsMasterList.length>0?true:false;
       console.log(this.claimsMasterList);
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.claimsMasterSearchSpinner);
       });
     }
   }


   exportExcel() {
    let header = ['Feature Name', 'Claims Type', 'Is Active', 'Created By', 'Created On'];
    let jsonKey = ['featureName', 'claimType', 'isActive', 'createdByUser', 'createdOn'];
    let data = this.claimsMasterList;
    var arrFinalData = [];
    var columnsKeyNames = [];
    for (var i = 0; i < data.length; i++) {
      var singleRow_temp = data[i];
      columnsKeyNames = Object.keys(singleRow_temp);
      var column0_temp = "";
      var column1_temp = "";
      var column2_temp = "";
      var column3_temp = "";
      var column4_temp = "";
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == jsonKey[0]) {
          column0_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[1]) {
          column1_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[2]) {
          if(singleRow_temp[columnsKeyNames[j]] == true){
            column2_temp = 'ACTIVE';
          }
          if(singleRow_temp[columnsKeyNames[j]] == false){
            column2_temp = 'INACTIVE';
          }
        }
        if (columnsKeyNames[j] == jsonKey[3]) {
          column3_temp = singleRow_temp[columnsKeyNames[j]].firstName;
        }
        if (columnsKeyNames[j] == jsonKey[4]) {
          column4_temp = this.datepipe.transform(singleRow_temp[columnsKeyNames[j]],'MM/dd/yyyy');
        }
      }
      arrFinalData.push([column0_temp,column1_temp,column2_temp,column3_temp,column4_temp])
    }
    this.excelService.exportExcel(header,arrFinalData,'claim-master-search')
  }

  getFeatures() {
    this.claimsMasterService.getFeatures().subscribe(data => {
      this.userFeatures = data;
      if (this.userFeatures.length > 0) {
        this.claimsMasterForm.get('featureId').setValue(this.userFeatures[0].featureId)
      }
    },
      error => {
        console.log(error)
      })
  }

  getClaimTypeNotAdded(){
    let featureId = this.claimsMasterForm.get('featureId').value;
    this.claimsMasterService.getClaimTypeNotAddedForFeatureId(featureId).subscribe(data => {
      this.userClaims = data;
      if (this.userClaims.length > 0) {
        this.claimsMasterForm.get('claimTypeId').setValue(this.userClaims[0].claimTypeId);
      }else{
        this.claimsMasterForm.get('claimTypeId').setValue(null);
      }
    },
    error =>{
      console.log(error);
    })
  }

  userFeaturesOnChange(id){
    this.userClaims = [];
    this.getClaimTypeNotAdded();
  }

  exportClaimMaster() {
    this.applyFilter();
    this.claimsMasterSearchParam = 
     {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
     };
     this.claimsMasterService.ExportClaimMasterResult(this.claimsMasterSearchParam).subscribe(res => {
     var blob = new Blob([res.body], { type: res.body.type });
     const file = new File([blob],"ClaimMaster.xlsx", { type: res.body.type });
     fs.saveAs(file);
     });
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      console.log("length is "+tempColumn.length);
      return true;
    }
    return false;
  }

  checkDeletePermission() {
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.claimMasterId)
       }
       this.items.push(deleteItem);
    }
  }

  getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }
} 

